type TagProps = {
  label: string;
  color?: string;
};

const Tag = ({ label, color = "bg-blue-600" }: TagProps) => {
  return (
    <span
      className={`text-white text-xs px-3 py-1 rounded-full shadow-md ${color}`}
    >
      {label}
    </span>
  );
};

export default Tag;
